export default __webpack_public_path__ + "static/media/ic-no-photo.27f0df9f.svg";